import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'elsi-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent {
  readonly currentYear = signal(new Date().getFullYear());
}
